var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import { useToast } from '@doordash/component-toast';
import { Icon, Inset } from '@doordash/design-language';
import { useDispatch } from 'react-redux';
import { addMembers } from '../members_slice';
import track from '../../utils/track';
import AddMembersForm from './add_members_form';
export var getArrayFromMemberList = function (inputString) {
    if (inputString && inputString.trim()) {
        return inputString.trim().split(/[\s,]+/);
    }
    return [];
};
export var AddMembersModal = function (_a) {
    var teamAccountId = _a.teamAccountId, onClose = _a.onClose, onMemberAdded = _a.onMemberAdded, maxMembersLimit = _a.maxMembersLimit, totalMembersCount = _a.totalMembersCount;
    var dispatch = useDispatch();
    var displayToast = useToast().displayToast;
    var _b = __read(React.useState({}), 2), formResponse = _b[0], setFormResponse = _b[1];
    var _c = __read(React.useState(false), 2), showLimitationErrorBanner = _c[0], setShowLimitationErrorBanner = _c[1];
    var handleFormSubmit = function (values, actions) {
        var membersArray = getArrayFromMemberList(values.members);
        var membersObject = {
            emailsList: membersArray,
            teamAccountId: teamAccountId,
        };
        var numEmails = membersArray.length;
        if (Boolean(maxMembersLimit) &&
            totalMembersCount + numEmails > maxMembersLimit) {
            setShowLimitationErrorBanner(true);
            actions.setSubmitting(false);
            return;
        }
        dispatch(addMembers(membersObject))
            .unwrap()
            .then(function () {
            track('workportal_submit_add_members', {
                member_emails_count: numEmails,
                team_account_id: teamAccountId,
            });
            displayToast({
                icon: Icon.Types.Check,
                text: numEmails === 1
                    ? '1 email added successfully'
                    : numEmails + " emails added successfully",
                insetFromEdge: Inset.Sizes.XxxLarge,
            });
            onMemberAdded();
            onClose();
        }, function (errorResponse) {
            setFormResponse({
                response: {
                    success: false,
                    errorMessage: errorResponse.error || 'There was an error.',
                },
            });
        })
            .finally(function () {
            actions.setSubmitting(false);
        });
    };
    return (React.createElement(Modal, { onClose: onClose, title: "Add Members" },
        React.createElement(AddMembersForm, { handleFormSubmit: handleFormSubmit, formResponse: formResponse, onClose: onClose, maxMembersLimit: maxMembersLimit, totalMembersCount: totalMembersCount, showLimitationErrorBanner: showLimitationErrorBanner, teamAccountId: teamAccountId })));
};
export default AddMembersModal;
